'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'timeline', ( years ) => ({

		timelineInner: null,
		tab          : `#tab${years[0]}`,
		yearsList    : years,
		currentYear  : years[0],
		prevYear     : null,
		nextYear     : years[1] || null,

		tabTo( year ) {
			this.currentYear = parseInt( year );
			this.tab         = `#tab${year}`;
			this.setPreviousYear();
			this.setNextYear();
		},

		// scrollTo( year ) {

		// 	// Set the current year.
		// 	this.currentYear = parseInt( year );

		// 	// Find the element with the data-year attribute that matches the year variable.
		// 	const element = this.timelineInner.querySelector( `[data-year='${this.currentYear}']` );

		// 	// Scroll to the element.
		// 	this.timelineInner.scrollLeft = element.offsetLeft;

		// 	// Set the previous and next buttons.
		// 	this.setPreviousYear();
		// 	this.setNextYear();
		// },

		// scrollNext() {

		// 	if ( null !== this.nextYear ) {

		// 		// Define the target element based on the "next" year.
		// 		const element = this.timelineInner.querySelector( `[data-year='${this.nextYear}']` );

		// 		// Scroll to the element.
		// 		this.timelineInner.scrollLeft = element.offsetLeft;

		// 		// Set the current year.
		// 		this.currentYear = parseInt( element.dataset.year );

		// 		// Set the previous and next buttons.
		// 		this.setPreviousYear();
		// 		this.setNextYear();
		// 	}
		// },

		// scrollPrev() {

		// 	if ( null !== this.prevYear ) {

		// 		// Define the target element based on the "previous" year.
		// 		const element = this.timelineInner.querySelector( `[data-year='${this.prevYear}']` );

		// 		// Scroll to the element.
		// 		this.timelineInner.scrollLeft = element.offsetLeft;

		// 		// Set the current year.
		// 		this.currentYear = parseInt( element.dataset.year );

		// 		// Set the previous and next buttons.
		// 		this.setPreviousYear();
		// 		this.setNextYear();
		// 	}
		// },

		// init() {
		// 	this.timelineInner = this.$el.querySelector( '.timeline__inner' );
		// 	this.nextYear      = this.$el.querySelector( `[data-year='${this.nextYear}']` );

		// 	// Set our years.
		// 	this.timelineInner.querySelectorAll( '.timeline__year' ).forEach( ( year ) => {
		// 		this.yearsList.push( parseInt( year.dataset.year ) );
		// 	});

		// 	this.setPreviousYear();
		// 	this.setNextYear();
		// },

		setPreviousYear() {

			// Find the index of the yearsList array based on the selected "year" variable.
			const index = this.yearsList.indexOf( this.currentYear );

			// If we're not at the beginning of the array, set the previous
			// year, which is the *next* element in the array.
			if ( 0 !== index ) {
				this.prevYear = this.yearsList[index - 1];
			} else {
				this.prevYear = null;
			}
		},

		setNextYear() {

			// Find the index of the yearsList array based on the selected "year" variable.
			const index = this.yearsList.indexOf( this.currentYear );

			// If we're not at the end of the array, set the next
			// year, which is the *previous* element in the array.
			if ( this.yearsList.length - 1 !== index ) {
				this.nextYear = this.yearsList[index + 1];
			} else {
				this.nextYear = null;
			}
		},

	}) );
});
